module.exports = __webpack_public_path__ + "img/login-page-ched-logo.74e70ae0.png";